export var createPhoneApi = function (baseUrl, http) {
    var ticketsUrl = baseUrl + "/tickets";
    var ticketUrl = function (id) { return ticketsUrl + "/" + id; };
    var callsUrl = function (id) { return ticketUrl(id) + "/calls"; };
    var phoneNumbersUrl = baseUrl + "/twilio/admin/numbers";
    var phoneUrl = ticketsUrl + "/phone";
    var tokenUrl = phoneUrl + "/token";
    var callUrl = ticketsUrl + "/call";
    var invitationUrl = callUrl + "/invitation";
    return {
        makeCallFromTicket: function (callFromTicketDto) {
            var ticketId = callFromTicketDto.ticketId;
            return http.post("" + callsUrl(ticketId), callFromTicketDto);
        },
        getPhoneNumbers: function () {
            return http.get(phoneNumbersUrl);
        },
        getToken: function (ttlSeconds) {
            var query = ttlSeconds ? "?ttlSeconds=" + ttlSeconds : '';
            return http.get("" + tokenUrl + query);
        },
        terminateCurrentCall: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/terminate", {});
        },
        inviteAgentToCurrentCall: function (addParticipantDto) {
            var ticketId = addParticipantDto.ticketId, callId = addParticipantDto.callId, invitedAgentId = addParticipantDto.invitedAgentId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/inviteAgent", { invitedAgentId: invitedAgentId });
        },
        abortParticipantCall: function (addParticipantDto) {
            var ticketId = addParticipantDto.ticketId, callId = addParticipantDto.callId, invitedAgentId = addParticipantDto.invitedAgentId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/participants/" + invitedAgentId + "/abort", {});
        },
        holdCurrentCall: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/hold", {});
        },
        unholdCurrentCall: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/unhold", {});
        },
        muteCurrentCaller: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/mute", {});
        },
        unmuteCurrentCaller: function (currentCallDto) {
            var ticketId = currentCallDto.ticketId, callId = currentCallDto.callId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/unmute", {});
        },
        joinCall: function (joinCallDto) {
            var ticketId = joinCallDto.ticketId, callId = joinCallDto.callId;
            return http.post(ticketUrl(ticketId) + "/calls/" + callId + "/listen", {});
        },
        getPhoneCall: function (getPhoneCallDto) {
            var ticketId = getPhoneCallDto.ticketId, callId = getPhoneCallDto.callId;
            return http.get(ticketUrl(ticketId) + "/calls/" + callId);
        },
        getCallInvitationInfo: function (getCallInvitationDto) {
            var invitationClientKey = getCallInvitationDto.invitationClientKey;
            return http.get(invitationUrl + "?invitationClientKey=" + invitationClientKey);
        },
        transferCallToQueue: function (dto) {
            return http.post(callsUrl(dto.ticketId) + "/" + dto.callId + "/transfer", { queueId: dto.queueId });
        },
        warmTransferCallToQueue: function (dto) {
            return http.post(callsUrl(dto.ticketId) + "/" + dto.callId + "/warmTransfer", { queueId: dto.queueId });
        },
        makeCallFromTicketsList: function (callFromTicketsListDto) {
            return http.post(phoneUrl + "/outbound", callFromTicketsListDto);
        },
        getIncomingCallData: function (key) {
            return http.get(callUrl + "/incomingClientCallData?incomingClientCallKey=" + key);
        },
        pausePhoneCallRecording: function (dto) {
            return http.post(callsUrl(dto.ticketId) + "/" + dto.phoneCallId + "/pauseRecording", {});
        },
        resumePhoneCallRecording: function (dto) {
            return http.post(callsUrl(dto.ticketId) + "/" + dto.phoneCallId + "/resumeRecording", {});
        }
    };
};
//# sourceMappingURL=index.js.map